<template>
	<div class="mt-2 mx-2">
		<Header
			:loading="loading"
			:selectPlaceService="selectPlaceService"
			@setSelectPlaceService="setSelectPlaceService"
		/>
		<router-view />
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Pusher from 'pusher-js';

export default {
	name: 'Management',
	components: {
		Header: () => import('@/components/lodgings/Header'),
	},
	data() {
		return {
			pusher: null,
			channel: null,
			selectPlaceService: false,
		};
	},
	computed: {
		...mapGetters({
			loading: 'User/globalLoading',
			selectedPlace: 'Lodging/selectedPlace',
			places: 'Lodging/places',
		}),
	},
	created() {
		if (!this.$vuetify.breakpoint.lgAndUp)
			document
				.getElementById('viewport')
				.setAttribute(
					'content',
					'width=600,  initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
				);
		this.pusher = new Pusher(process.env.VUE_APP_PUSHER_KEY, {
			cluster: process.env.VUE_APP_PUSHER_CLUSTER,
		});
		this.pusher.connection.bind('update', function(err) {
			console.error(err);
		});
		this.channel = this.pusher.subscribe('lodging');
		this.channel.bind('update', data => this.$emit('fetch-lodgings', data));
		this.$on('fetch-lodgings', async data => {
			if (this.userProfile._id === data.idCompany) {
				this.setUpdateMap(true);
				// obtiene los lodgin de un place
				if (this.selectedPlace && this.$route.name == 'activities')
					setTimeout(() => {
						this.fetchLodgings(this.selectedPlace.value);
					}, 5);
				// obtiene los lodging de todo los lugares del admin "ver todos"
				else {
					await this.getLodgingsOfAdmin();
				}
				if (data.getPlace) {
					await this.fetchPlace();
				}
			}
		});
	},
	methods: {
		setSelectPlaceService(selected) {
			this.selectPlaceService = selected;
		},
		...mapActions({
			fetchPlace: 'Lodging/fetchPlace',
			fetchLodgings: 'Lodging/fetchLodgings',
			getLodgingsOfAdmin: 'Lodging/getLodgingsOfAdmin',
		}),
		...mapMutations({
			setLodgings: 'Lodging/setLodgings',
			setUpdateMap: 'Lodging/setUpdateMap',
		}),
	},
};
</script>
